import { load } from '@cashfreepayments/cashfree-js';

export const loadCashfree = async () => {
  const cashfree = await load({ mode: 'sandbox' }); // switch to 'production' later
  return cashfree;
};
